import * as t from "io-ts";
import { withFallback } from "io-ts-types";
import { defaultDispatcherViewT } from "./org-settings";
export const defaultCopyOptionT = t.union([
    t.literal("COPY_ORDER"),
    t.literal("COPY_WITH_INVOICE_LINES"),
    t.literal("COPY_WITH_INVOICE_LINES_RESET_QTY"),
    t.literal("COPY_TO_DRIVER_ROUTES"),
]);
export const userSettingsT = t.strict({
    defaultDispatcherView: withFallback(defaultDispatcherViewT, "ROUTES_VIEW"),
    removeDropoffByDefault: withFallback(t.boolean, false),
    defaultCopyOption: withFallback(defaultCopyOptionT, "COPY_WITH_INVOICE_LINES_RESET_QTY"),
    defaultCreateCopyOption: withFallback(defaultCopyOptionT, "COPY_WITH_INVOICE_LINES"),
});
export const userSettingsWithId = t.intersection([
    userSettingsT,
    t.strict({ userId: t.string }),
]);
//# sourceMappingURL=user-settings.js.map